(() => {
  function selectUnitPrice(prices, variantId, planId) {
    const variant = prices[String(variantId)];
    if (!variant) return null;
    const value = planId ? variant.plans?.[String(planId)] : variant.default;
    return typeof value === 'string' && value.trim() ? value : null;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {selectUnitPrice};
  if (typeof document === 'undefined' || window.guyaUnitPricesReady) return;
  window.guyaUnitPricesReady = true;
  const instances = new Map();
  function initialize(scope = document) {
    scope.querySelectorAll('.guya-product-main').forEach(root => {
      if (instances.has(root)) return;
      const data = root.querySelector('[data-guya-unit-prices]');
      if (!data) return;
      let prices;
      try { prices = JSON.parse(data.textContent); } catch { return; }
      let scheduled = false;
      let destroyed = false;
      function update() {
        scheduled = false;
        if (destroyed) return;
        const variant = root.querySelector('select[name="id"]');
        const target = root.querySelector('[data-unit-price]');
        if (!variant || !target) return;
        const form = variant.closest('form');
        let planId = form?.querySelector('input[name="selling_plan"]')?.value || '';
        const sealChoice = root.querySelector('input.sls-option:checked');
        if (sealChoice?.value === 'one_time') planId = '';
        else if (!planId && sealChoice) {
          const interval = root.querySelector('select[name="subs_interval"]');
          if (!interval?.value) return;
          planId = interval.value;
        }
        const value = selectUnitPrice(prices, variant.value, planId);
        if (!value || target.textContent.trim() === value) return;
        const money = document.createElement('span');
        money.className = 'money';
        money.textContent = value;
        target.replaceChildren(money);
      }
      function schedule() {
        if (scheduled || destroyed) return;
        scheduled = true;
        requestAnimationFrame(update);
      }
      const observer = new MutationObserver(schedule);
      observer.observe(root, {subtree:true, childList:true, attributes:true, attributeFilter:['value','checked','aria-checked']});
      root.addEventListener('change', schedule);
      instances.set(root, () => { destroyed = true; observer.disconnect(); root.removeEventListener('change', schedule); });
      schedule();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, root) => {
      if (event.target.contains(root)) { destroy(); instances.delete(root); }
    });
  });
})();
